import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1zm1-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9 4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1H9zm1-3a3 3 0 0 0-3 3v3h10V4a3 3 0 0 0-3-3zM15 20a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1h6zm-1 3a3 3 0 0 0 3-3v-3H7v3a3 3 0 0 0 3 3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }